const closeMobileMenu = () => {
    const mobileMenu = document.querySelector('.mobile-menu');
    const headerMobile = document.querySelector('.header__mobile');

    if (mobileMenu?.classList.contains('mobile-menu--active')) {
        mobileMenu.classList.remove('mobile-menu--active');
    }

    if (headerMobile?.classList.contains('active')) {
        headerMobile.classList.remove('active');
    }
};

const DonateMenu = () => {
    let items = document.querySelectorAll('.donate-menu__item--parent');

    Array.from(items).forEach(item => {
        const link = item.querySelector('a');

        // Lock width based on initial size
        if (link) {
            const width = link.offsetWidth;
            link.style.width = `${width}px`;
        }

        if (link && !link.dataset.originalText) {
            link.dataset.originalText = link.textContent;
        }

        item.addEventListener('click', e => {
            const isActive = item.classList.contains('donate-menu__item--active');

            if (e.target.closest('.donate-menu__link')) {
                e.preventDefault();
            }

            if (!isActive) {
                closeMobileMenu(); // close mobile menu
            }

            item.classList.toggle('donate-menu__item--active');

            if (link) {
                link.textContent = item.classList.contains('donate-menu__item--active')
                    ? 'Close'
                    : link.dataset.originalText;
            }
        });
    });
};

export default DonateMenu;
